import { render, staticRenderFns } from "./JournalValidation.vue?vue&type=template&id=361cb3f6&"
import script from "./JournalValidation.vue?vue&type=script&lang=js&"
export * from "./JournalValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports